import React from "react";
import ClientCard from "./ClientCard";
import ClientDetails from "./ClientDetails";

const ViewClientDetails: React.FC<{ admin: any }> = ({ admin }) => {
    return (
        <ClientCard title="Client Details">
            <ClientDetails admin={admin} />
        </ClientCard>
    );
};

export default ViewClientDetails;
